<template>
  <div class="list-box bg-gray-100 rounded-lg">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailRiChengDetailYiChengList"
      data-title="议程管理"
    >
      <el-input
        v-model="state.params.keywords"
        class="c-search-white"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
        v-if="!props.search"
      >
        添加
      </el-button>
    </div>
    <div class="content c-table-box mt-2 bg-white rounded-lg">
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        class="p-2.5"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />

        <el-table-column :width="200">
          <template #header>
            <div class="c-table-col-header" label1="名称" label2="时间" />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value1="row.name">
              <template #bottom>
                <div class="flex items-end gap-x-2">
                  <text class="text-gray-700 text-xs">
                    {{
                      $dayjs(row.start_time, "HH:mm:ss").format("HH:mm") +
                      " ~ " +
                      $dayjs(row.end_time, "HH:mm:ss").format("HH:mm")
                    }}
                  </text>
                  <text class="text-gray-400 text-xs">{{ row.date }}</text>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="嘉宾信息">
          <template #default="{ row }">
            <div
              class="flex flex-wrap gap-5"
              v-if="row.meetingAttendeeAgendaList?.length > 0"
            >
              <div
                class="flex items-center gap-x-2"
                v-for="item in row.meetingAttendeeAgendaList"
                :key="item"
              >
                <c_Avatar
                  v-if="item.meetingAttendee?.conferee?.id"
                  :file_url="
                    item.meetingAttendee?.conferee?.avatar_attachment?.file_url
                  "
                  :size="10"
                  :title="item.meetingAttendee?.conferee?.name?.slice(0, 1)"
                />
                <div class="h-10">
                  <ul class="flex items-center gap-x-1">
                    <strong>{{ item.meetingAttendee?.conferee?.name }}</strong>
                    <c_sex
                      v-if="item.meetingAttendee?.conferee?.id"
                      :value="item.meetingAttendee?.conferee?.sex"
                    />
                    <el-tag
                      v-if="item.d_attend_role_name"
                      size="small"
                      color="#776034"
                      :hit="true"
                      effect="light"
                      style="color: #edca4f; border: 0; font-size: 11px"
                    >
                      {{ item.d_attend_role_name }}
                    </el-tag>
                  </ul>
                  <ul class="text-xs text-gray-400">
                    {{
                      item.meetingAttendee?.conferee?.pinyin
                    }}
                  </ul>
                </div>
              </div>
            </div>
            <span v-else>
              <text class="text-gray-400 text-xs">暂未配置嘉宾</text>
              <el-button
                v-if="!props.search"
                type="success"
                link
                size="small"
                @click="
                  state.selectItem = row;
                  state.showSelect = true;
                "
              >
                去配置
              </el-button>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          align="center"
          :width="260"
          v-if="!props.search"
        >
          <template #default="{ row }">
            <el-button
              type="warning"
              :icon="Edit"
              link
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
            >
              编辑
            </el-button>
            <el-button
              type="success"
              :icon="Setting"
              link
              @click="
                state.selectItem = row;
                state.showSelect = true;
              "
            >
              嘉宾配置
            </el-button>
            <el-button type="danger" :icon="Delete" link @click="onDelete(row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showInfo"
    :title="state.selectId ? '编辑议程' : '新建议程'"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
    :width="500"
  >
    <c_info
      :meeting_id="props.meeting_id"
      :meeting_schedule_id="props.meeting_schedule_id"
      :meeting_schedule_date="props.meeting_schedule_date"
      :id="state.selectId"
      @close="
        state.showInfo = false;
        onLoad();
      "
    />
  </el-dialog>
  <el-dialog
    v-model="state.showSelect"
    :title="'嘉宾配置-' + state.selectItem?.name"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showSelect = false;
      }
    "
    style="height: 80vh"
  >
    <c_select
      :meeting_id="props.meeting_id"
      :meeting_schedule_id="props.meeting_schedule_id"
      :meeting_agenda_id="state.selectItem?.id"
      @close="
        state.showSelect = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  meeting_agenda_page,
  meeting_agenda_delete,
  meeting_agenda_attendee_delete,
} from "@/http/meeting";
import { onDeleteConfirm } from "@/utils/funcs";

import c_info from "./Info.vue";
import c_select from "./Select.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    meeting_id: Number,
    meeting_schedule_id: Number,
    meeting_schedule_date: String,
    search: Boolean,
  },
  components: {
    c_info,
    c_select,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.meeting_schedule_id = props.meeting_schedule_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;
      meeting_agenda_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(meeting_agenda_delete, row.id, onLoad, {
        filed: "会议议程",
        name: row.name,
      });
    };

    return { state, props, onLoad, onDelete };
  },
};
</script>

<style lang="scss" scoped></style>
